<!-- 由 woniu6162 创建于 2019-09-11 星期三 -->
<template>
  <div
    v-if="data.showAddress"
    class="ponent-popup"
    @click.self="data.showAddress = false"
  >
    <van-area
      title="标题"
      :area-list="areaList"
      :columns-num="2"
      :columns-placeholder="['请选择', '请选择']"
      @cancel="bindCancel"
      @confirm="bindConfirm"
    />
  </div>
</template>
<script>
import Vue from 'vue'
import { areaList } from '@vant/area-data'
import { Area } from 'vant'
Vue.use(Area)
export default {
  name: 'address-popup',
  mixins: [],
  components: {},
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      areaList
    }
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {},

  destroyed() {},

  methods: {
    bindCancel() {
      this.data.showAddress = false
    },
    bindConfirm(e) {
      for (let i = 0; i < e.length; i++) {
        if (e[i].code === '') {
          this.$Toast('省市必须都填写')
          return
        }
      }
      this.$emit('confirm', e)
    }
  }
}
</script>

<style lang="scss">
.ponent-popup {
  position: fixed;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  z-index: 99;
  bottom: 0;
  left: 0;
  & > div {
    position: fixed;
    width: 100%;
    left: 0;
    bottom: 0;
  }
}
</style>
